export const isEven = (num: number) => {
  return num % 2 === 0;
};
